// gatsby-browser.js
import React from "react"
import { AuthProvider } from "./src/hooks/useAuth"

// Global CSS
import "./src/styles/global/reset.css"
import "./src/styles/global/variables.css"
import "./src/styles/global/layout.css"
import "./src/styles/global/typography.css"
import "./src/styles/global/elements.css"
import "./src/styles/global/utilities.css"
import "./src/styles/global/links.css"
import "./src/styles/global/helpers.css"
import "./src/styles/global/buttons.css"
import "./src/styles/global/tags.css"

// i18n initialization
import "./src/i18n"

// Wrap root element so every component can access AuthProvider
export const wrapRootElement = ({ element }) => <AuthProvider>{element}</AuthProvider>

// Optional: Dark mode toggle logic
export const onInitialClientRender = () => {
  const theme = localStorage.getItem("theme")
  if (theme === "dark") document.body.classList.add("dark")

  const darkToggle = document.getElementById("dark-mode-button")
  if (!darkToggle) return

  darkToggle.textContent = document.body.classList.contains("dark") ? "☀️" : "🌙"

  darkToggle.onclick = () => {
    const isDark = document.body.classList.toggle("dark")
    localStorage.setItem("theme", isDark ? "dark" : "light")
    darkToggle.textContent = isDark ? "☀️" : "🌙"
  }
}
